//#region Imports

import { NgModule } from '@angular/core';
import { Route, RouterModule, Routes } from '@angular/router';

import { environment } from '../environments/environment';
import { AuthenticateGuard } from './guards/authenticate/authenticate.guard';
import { SetupAuthenticationGuard } from './guards/authenticate/setup-authentication.guard';

//#endregion

/**
 * As configurações para as rotas que NÃO precisam de autenticação
 */
export const unAuthenticatedRoute: Partial<Route> = {
  canActivate: [SetupAuthenticationGuard, AuthenticateGuard],
  data: { routeToRedirect: environment.config.redirectToWhenAuthenticated, unprotectedRoute: true }
};

/**
 * As configurações para as rotas que PRECISAM de autenticação
 */
export const authenticatedRoute: Partial<Route> = {
  canActivate: [SetupAuthenticationGuard, AuthenticateGuard],
  data: { routeToRedirect: environment.config.redirectToWhenUnauthenticated, protectedRoute: true }
};

const routes: Routes = [
  { path: '', redirectTo: 'main/inicio', pathMatch: 'full' },
  { path: 'main', loadChildren: () => import('./pages/main/main.module').then(m => m.MainModule), ...authenticatedRoute },
  { path: 'auth', loadChildren: () => import('./pages/auth/auth.module').then(m => m.AuthModule), ...unAuthenticatedRoute },
  { path: '**', redirectTo: 'main/inicio' },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      paramsInheritanceStrategy: 'always',
      relativeLinkResolution: 'legacy',
      anchorScrolling: "enabled",
      onSameUrlNavigation: "reload",
      scrollPositionRestoration: "enabled",
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {
}
